import Auth from 'live/services/authorization'

export function canManageDataImport(): boolean {
    return Auth.Permission.isAdmin || Auth.Permission.SUPER_USER || Auth.Permission.MANAGE_HIGH_FREQUENCY_DATA
}

export function canManageCrew(): boolean {
    return Auth.Permission.isAdmin || Auth.Permission.SUPER_USER || Auth.Permission.MANAGE_CREWS
}

export function canManageWells(): boolean {
    return Auth.Permission.isAdmin || Auth.Permission.SUPER_USER || Auth.Permission.MANAGE_WELLS
}
